angular.module 'zc.core'

# Remove trailing slash
.config ($urlRouterProvider) ->
  $urlRouterProvider.rule ($injector, $location) ->
    path = $location.url()
    return path.slice 0, -1 if path[path.length - 1] is "/"
    return path.replace("/?", "?") if path.indexOf("/?") > -1
    return # no state change occurs when return nothing

.config ($urlRouterProvider) ->
  # It should redirect to requested url
  # since not all urls are handled by AngularJS
  $urlRouterProvider.otherwise ($injector, $location) ->
    # redirect to 404 if unknown url
    $state = $injector.get('$state')
    Devise = $injector.get('Devise')

    # forward to login page if $$url is root
    if !Devise.currentUser && ($location.path() == '/' || $location.path() == '')
      $state.go('users.signIn', null, { })
    else if Devise.currentUser && ($location.path() == '/' || $location.path() == '')
      $state.go('admin.home')
    else
      $state.go('404', null, { location: false })

    return




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/config/zc.core.routes.js.coffee